import React, { FC, useEffect } from 'react';
import './logo-with-site-name.scss';
import { refreshToken } from '/react4xp/parts/logo-with-site-name/actions';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const LogoWithSiteName: FC = ({ config, logoImg, user, className, language, mode }) => {
    const setTimeLimit = (seconds: number) => {
        let time = new Date();

        const limit = seconds * 1000;

        let timer = setInterval(() => {
            let time2 = new Date();

            if (time2 - time >= limit) {
                clearInterval(timer);
                // logout
                open('/ru/_/idprovider/jwt/logout', '_self');
            } else {
                // отправляем запрос на обновление тоукена
                refreshToken().then(() => console.log('Token has been refreshed!'));
            }
        }, limit);

        const root = document.getElementById('root');

        root.addEventListener(
            'mouseover',
            () => {
                time = new Date();
            },
            false
        );
    };

    const getTokenLifespan = (token: string): number => {
        if (token) {
            const { exp, iat } = jwtDecode<any>(token);
            const remainingTime = exp - iat;
            return remainingTime > 0 ? remainingTime : 0;
        }

        return 0;
    };

    useEffect(() => {
        if (mode === 'live' && user) {
            // Получаем время жизни тоукена

            const token = Cookies.get('token');

            if (token) {
                console.log('token expires_in', getTokenLifespan(token));
                setTimeLimit(getTokenLifespan(token));
            }
        }
    }, []);

    return (
        <div
            className={`logo-with-site-name ${className}`}
            onClick={() => window.open('/' + language, '_self')}
        >
            {logoImg && (
                <img
                    className="me-2 logo"
                    src={logoImg}
                />
            )}
            <div>
                <h1>
                    <b>{config.titleOne}</b>
                </h1>
                <h1>
                    <b>{config.titleTwo}</b>
                </h1>
                <h1
                    style={{
                        fontWeight: 400,
                    }}
                >
                    {config.titleThree}
                </h1>
            </div>
        </div>
    );
};

export default (props) => <LogoWithSiteName {...props} />;
